<!-- <app-iri-lock *ngIf="!isPremiumUser"></app-iri-lock> -->
<app-feature-locked-card
   *ngIf="!isPremiumUser && !isSample"
   heading="ISRI Report"
   text="A comprehensive ethical and sustainability screening of the company which specifies how well a stock aligns with
        ISRI values through a Shariah-compliant lens!"
   (viewSampleClicked)="onViewSampleClicked('iri_report')"
   [iriPageFeature]="true"
   componentPage="shariah_compliance_report"
>
</app-feature-locked-card>

<div *ngIf="isPremiumUser || isSample">
   <div class="header_title">
      <h5>Islamic Socially Responsible Investing (ISRI) Score:</h5>
      <p style="display: flex; flex-direction: column">
         The ISRI Score reflects how well a company aligns with ethical,
         socially responsible, and Islamically guided investment principles. It
         provides a structured evaluation of a company’s impact on society,
         governance standards, and business practices, enabling investors to
         integrate Shariah screening with broader responsible investment
         considerations.

         <!-- <span style="padding-top: 10px"
            >Explore the Essential <a href="assets/Musaffa_ISRI.pdf" target="_blank" class="link_view_sample"
               >ISRI Product Overview</a
            ></span
         > -->
         <span style="padding-top: 10px">
            Explore the Essential
            <a href="assets/Musaffa_ISRI.pdf" target="_blank" class="link_view_sample">
               ISRI GUIDE
            </a>
         </span>
      </p>
   </div>

   <div class="iri_scrore_rew">
      <div class="iri_score_col">
         <app-musaffa-score
            [musaffaData]="musaffaData"
            [isSample]="isSample"
         ></app-musaffa-score>
      </div>

      <div class="iri_score_col">
         <app-community-score
            [communityData]="communityData"
            [symbol]="symbol"
            [symbolMainTicker]="symbolMainTicker"
            (ratingTaskCompleted)="onRatingCompleted($event)"
            [isSample]="isSample"
         >
            <!-- This must match -->
         </app-community-score>
      </div>
   </div>

   <div class="score__rating_row">
      <app-score-rating-slider
         [musaffaData]="musaffaData"
         [communityData]="communityData"
      ></app-score-rating-slider>
   </div>

   <div class="assessment-wrapper">
      <table class="table">
         <thead>
            <tr>
               <th width="33.333%">Core Islamic & Ethical Criteria</th>
               <th width="33.333%" style="text-align: center">
                  Musaffa ISRI Score
               </th>
               <th width="33.333%"  style="text-align: center">Community ISRI Score</th>
            </tr>
         </thead>

         <tbody>
            <!-- Community Impact & Social Controversies -->
            <tr>
               <td>
                  <p>
                     Community Impact & Social Controversies (Maslahah)
                     <span
                        [ngbTooltip]="tooltipTemplateCommunity"
                        placement="top"
                        [tooltipClass]="'tooltip_white_bg'"
                        style="
                           display: inline-block;
                           cursor: pointer;
                           text-align: center;
                        "
                     >
                        <img
                           src="../../../../assets/icons/IconInfo.svg"
                           alt="Info"
                        />
                     </span>
                  </p>

                  <ng-template #tooltipTemplateCommunity>
                     <div>
                        Assesses the company’s contribution to social upliftment,
                        particularly for underserved groups, and the clarity of
                        its strategy and reported outcomes. It also evaluates
                        involvement in any controversies or activities that may
                        harm people or communities, as well as the company’s
                        response to reputational challenges.
                        <br /><br />
                        <strong>Ethical Principles:</strong>
                        <ul style="margin-bottom: 0; padding-left: 15px;" class="tooltip-list-iri" >
                           <li>
                              Community Investment & Alignment with Social
                              Upliftment
                           </li>
                           <li>Reputational Risks & Social Controversies</li>
                        </ul>
                     </div>
                  </ng-template>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="
                           musaffaData?.community_impact_and_reputation ?? 0
                        "
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        musaffaData?.community_impact_and_reputation ?? "-"
                     }}</span>
                  </div>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="
                           communityData?.community_impact_and_reputation ?? 0
                        "
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        communityData?.community_impact_and_reputation ?? "-"
                     }}</span>
                  </div>
               </td>
            </tr>

            <!-- Labor Practices & Human Rights -->
            <tr>
               <td>
                  <p>
                     Labor Practices & Human Rights  ('Adalah)
                     <span
                        [ngbTooltip]="tooltipTemplate1"
                        placement="top"
                        [tooltipClass]="'tooltip_white_bg'"
                        style="display: inline-block; cursor: pointer"
                     >
                        <img
                           src="../../../../assets/icons/IconInfo.svg"
                           alt="Info"
                        />
                     </span>
                  </p>
                  <ng-template #tooltipTemplate1>
                     <div>
                        Assesses how the company treats its employees, suppliers,
                        and broader stakeholders with respect to justice, dignity,
                        and equality.
                        <br /><br />
                        <strong>Ethical Principles:</strong>
                        <ul style="margin-bottom: 0; padding-left: 15px;" class="tooltip-list-iri" >
                           <li>Fair Labor & Dignity</li>
                           <li>Workplace Justice & Non-Discrimination</li>
                        </ul>
                     </div>
                  </ng-template>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="
                           musaffaData?.human_rights_and_labor_practices ?? 0
                        "
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        musaffaData?.human_rights_and_labor_practices ?? "-"
                     }}</span>
                  </div>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="
                           communityData?.human_rights_and_labor_practices ?? 0
                        "
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        communityData?.human_rights_and_labor_practices ?? "-"
                     }}</span>
                  </div>
               </td>
            </tr>

            <!-- Product & Sector Involvement -->
            <tr>
               <td>
                  <p>
                     Product & Sector Involvement
                     <span
                        [ngbTooltip]="tooltipTemplate2"
                        placement="top"
                        [tooltipClass]="'tooltip_white_bg'"
                        style="display: inline-block; cursor: pointer"
                     >
                        <img
                           src="../../../../assets/icons/IconInfo.svg"
                           alt="Info"
                        />
                     </span>
                  </p>
                  <ng-template #tooltipTemplate2>
                     <div>
                        Evaluates whether the company’s core business is consistent with Islamic values,
                        and whether it avoids harm and advances public benefit.
                        <br /><br />
                        <strong>Ethical Principles:</strong>
                        <ul style="margin-bottom: 0; padding-left: 15px;" class="tooltip-list-iri" >
                           <li>Shariah Screening & Product Purity</li>
                           <li>
                              Maslahah-Oriented Innovation & Social Benefit
                           </li>
                        </ul>
                     </div>
                  </ng-template>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="
                           musaffaData?.product_and_sector_involvement ?? 0
                        "
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        musaffaData?.product_and_sector_involvement ?? "-"
                     }}</span>
                  </div>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="
                           communityData?.product_and_sector_involvement ?? 0
                        "
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        communityData?.product_and_sector_involvement ?? "-"
                     }}</span>
                  </div>
               </td>
            </tr>

            <!-- Environmental Responsibility -->
            <tr>
               <td>
                  <p>
                     Environmental Responsibility (Khalifah)
                     <span
                        [ngbTooltip]="tooltipTemplate3"
                        placement="top"
                        [tooltipClass]="'tooltip_white_bg'"
                        style="display: inline-block; cursor: pointer"
                     >
                        <img
                           src="../../../../assets/icons/IconInfo.svg"
                           alt="Info"
                        />
                     </span>
                  </p>
                  <ng-template #tooltipTemplate3>
                     <div>
                        Looks at the company's environmental strategy, transparency,
                        and alignment with Islamic principles on stewardship.
                        <br /><br />
                        <strong>Ethical Principles:</strong>
                        <ul style="margin-bottom: 0; padding-left: 15px;" class="tooltip-list-iri">
                           <li>Environmental Stewardship</li>
                           <li>Preservation of Creation & Compliance</li>
                        </ul>
                     </div>
                  </ng-template>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="musaffaData?.environmental_responsibility ?? 0"
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        musaffaData?.environmental_responsibility ?? "-"
                     }}</span>
                  </div>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="
                           communityData?.environmental_responsibility ?? 0
                        "
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        communityData?.environmental_responsibility ?? "-"
                     }}</span>
                  </div>
               </td>
            </tr>

            <!-- Ethical Governance -->
            <tr>
               <td>
                  <p>
                     Ethical Governance (Amanah)
                     <span
                        [ngbTooltip]="tooltipTemplate4"
                        [tooltipClass]="'tooltip_white_bg'"
                        style="display: inline-block; cursor: pointer"
                     >
                        <img
                           src="../../../../assets/icons/IconInfo.svg"
                           alt="Info"
                        />
                     </span>
                  </p>
                  <ng-template #tooltipTemplate4>
                     <div>
                        Reviews internal accountability mechanisms, board ethics,
                        and overall commitment to justice, transparency, and trust.
                        <br /><br />
                        <strong>Ethical Principles:</strong>
                        <ul style="margin-bottom: 0; padding-left: 15px;" class="tooltip-list-iri">
                           <li>Trust & Leadership Ethics</li>
                           <li>Accountability & Ethical Governance</li>
                        </ul>
                     </div>
                  </ng-template>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="musaffaData?.ethical_governance ?? 0"
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        musaffaData?.ethical_governance ?? "-"
                     }}</span>
                  </div>
               </td>
               <td>
                  <div class="bar_slide_row">
                     <app-assessment-slider-right
                        [score]="communityData?.ethical_governance ?? 0"
                     ></app-assessment-slider-right>
                     <span class="score">{{
                        communityData?.ethical_governance ?? "-"
                     }}</span>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
   </div>

   <div class="mobile_assessment">
      <div class="assessment_title">Core Islamic & Ethical Criteria</div>

      <!-- Community Impact & Social Controversies -->
      <div class="assessment_section">
         <p>
            Community Impact & Social Controversies (Maslahah)
            <span
               [ngbTooltip]="tooltipTemplateCommunity"
               placement="top"
               [tooltipClass]="'tooltip_white_bg'"
               style="display: inline-block; cursor: pointer"
            >
               <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
            </span>
         </p>
         <div class="section_bar">
            <h6>Musaffa ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="musaffaData?.community_impact_and_reputation"
               ></app-assessment-slider-right>
               <span class="score">{{
                  musaffaData?.community_impact_and_reputation ?? "-"
               }}</span>
            </div>
         </div>
         <div class="section_bar">
            <h6>Community ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="communityData?.community_impact_and_reputation"
               ></app-assessment-slider-right>
               <span class="score">{{
                  communityData?.community_impact_and_reputation ?? "-"
               }}</span>
            </div>
         </div>
      </div>

      <!-- Labor Practices & Human Rights -->
      <div class="assessment_section">
         <p>
            Labor Practices & Human Rights ('Adalah)
            <span
               [ngbTooltip]="tooltipTemplate1"
               placement="top"
               [tooltipClass]="'tooltip_white_bg'"
               style="display: inline-block; cursor: pointer"
            >
               <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
            </span>
         </p>
         <div class="section_bar">
            <h6>Musaffa ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="musaffaData?.human_rights_and_labor_practices"
               ></app-assessment-slider-right>
               <span class="score">{{
                  musaffaData?.human_rights_and_labor_practices ?? "-"
               }}</span>
            </div>
         </div>
         <div class="section_bar">
            <h6>Community ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="communityData?.human_rights_and_labor_practices"
               ></app-assessment-slider-right>
               <span class="score">{{
                  communityData?.human_rights_and_labor_practices ?? "-"
               }}</span>
            </div>
         </div>
      </div>

      <!-- Product & Sector Involvement -->
      <div class="assessment_section">
         <p>
            Product & Sector Involvement
            <span
               [ngbTooltip]="tooltipTemplate2"
               placement="top"
               [tooltipClass]="'tooltip_white_bg'"
               style="display: inline-block; cursor: pointer"
            >
               <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
            </span>
         </p>
         <div class="section_bar">
            <h6>Musaffa ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="musaffaData?.product_and_sector_involvement"
               ></app-assessment-slider-right>
               <span class="score">{{
                  musaffaData?.product_and_sector_involvement ?? "-"
               }}</span>
            </div>
         </div>
         <div class="section_bar">
            <h6>Community ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="communityData?.product_and_sector_involvement"
               ></app-assessment-slider-right>
               <span class="score">{{
                  communityData?.product_and_sector_involvement ?? "-"
               }}</span>
            </div>
         </div>
      </div>

      <!-- Environmental Responsibility -->
      <div class="assessment_section">
         <p>
            Environmental Responsibility (Khalifah)
            <span
               [ngbTooltip]="tooltipTemplate3"
               placement="top"
               [tooltipClass]="'tooltip_white_bg'"
               style="display: inline-block; cursor: pointer"
            >
               <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
            </span>
         </p>
         <div class="section_bar">
            <h6>Musaffa ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="musaffaData?.environmental_responsibility"
               ></app-assessment-slider-right>
               <span class="score">{{
                  musaffaData?.environmental_responsibility ?? "-"
               }}</span>
            </div>
         </div>
         <div class="section_bar">
            <h6>Community ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="communityData?.environmental_responsibility"
               ></app-assessment-slider-right>
               <span class="score">{{
                  communityData?.environmental_responsibility ?? "-"
               }}</span>
            </div>
         </div>
      </div>

      <!-- Ethical Governance -->
      <div class="assessment_section">
         <p>
            Ethical Governance (Amanah)
            <span
               [ngbTooltip]="tooltipTemplate4"
               placement="top"
               [tooltipClass]="'tooltip_white_bg'"
               style="display: inline-block; cursor: pointer"
            >
               <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
            </span>
         </p>
         <div class="section_bar">
            <h6>Musaffa ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="musaffaData?.ethical_governance"
               ></app-assessment-slider-right>
               <span class="score">{{
                  musaffaData?.ethical_governance ?? "-"
               }}</span>
            </div>
         </div>
         <div class="section_bar">
            <h6>Community ISRI Score</h6>
            <div class="bar_slide_row">
               <app-assessment-slider-right
                  [score]="communityData?.ethical_governance"
               ></app-assessment-slider-right>
               <span class="score">{{
                  communityData?.ethical_governance ?? "-"
               }}</span>
            </div>
         </div>
      </div>
   </div>

   <app-score-radar-card
      [musaffaData]="musaffaData"
      [communityData]="communityData"
   ></app-score-radar-card>

   <div class="iri_desclaimer">
      <span style="font-weight: 600">Disclaimer:</span> Islamic Social
      Responsible Investing (ISRI) reports provided by Musaffa are based on our
      proprietary scoring system. These reports are intended for informational
      purposes only and do not constitute legal, investment, or financial
      advice, or an offer to buy or sell any financial product. Past performance
      is not indicative of future results. User-generated content reflects
      individual opinions and does not represent the views of Musaffa. We do not
      assume any responsibility. Please note that the ISRI is currently in beta
      and is still being actively developed. We are continuously working to
      enhance its accuracy, reliability, and overall performance. All content,
      materials and ISRI methodology are the exclusive property of Musaffa and
      are protected by copyright law. Any unauthorized copying, modifying or
      reproducing is strictly prohibited. Access the full disclaimer
      <a href="/disclaimer" target="_blank" class="link_view_sample">here</a>
   </div>

   <h4 class="title__explore_os" *ngIf="!isSample && relatedStocks.length > 0">Explore Other Stocks</h4>
   <div class="table-scroll-wrapper" *ngIf="!isSample && relatedStocks.length > 0">
      <app-dynamic-table
         [columns]="columns"
         [data]="relatedStocks"
         [page]="page"
         [useSpecialNameLayout]="true"
         [shouldShowCountAndActiveFilters]="false"
         [isDataLoading]="isLoading"
         [showResetButton]="true"
         [isSortingEnabled]="true"
         [sortColumn]="sortColumn"
         [sortOrder]="sortOrder"
         [type]="dataType"
         [showCompliance]="isSample"
         [showWatchlist]="false"
         [isIriPage]="true"
         [dontShowWatchlist]="true"
         [type]="'stock'"
      ></app-dynamic-table>
   </div>
</div>
